module.exports = __webpack_public_path__ + "static/media/correct.3345b3c9.mp3";